import { DisclaimersAllLang } from "src/app/common/services/external-settings/external-settings.interface";

import { Injectable } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { InternalSettings } from "src/app/common/services/internal-settings/internal-settings.interface";

@Injectable({
    providedIn: 'root'
})
export class TranslateUtilityService {

    constructor(private srvTranslate: TranslateService) { };

    public formatBoolean(value: any) {
        return value ? this.srvTranslate.instant('COMMON.YES') : this.srvTranslate.instant('COMMON.NO');
    }

    public formatNullString(value: any, key: string = 'COMMON.NULL') {
        return value ?? this.srvTranslate.instant(key);
    }

    instant(key: string | Array<string>, interpolateParams?: Object): any {
        return this.srvTranslate.instant(key, interpolateParams);
    }

    instantList(keys: Array<string>): string [] {
        return keys.map(key => this.srvTranslate.instant(key));
    }

    instantTemplate(key: string, templateName: string): string {
        let lookup = key + '_' + templateName.toUpperCase();
        let value = this.srvTranslate.instant(lookup);
        return value != lookup ? value : this.srvTranslate.instant(key);
    }

    join(list: string[], delimiter: string = ", ", lastElement: string = " and ") {

        let buffer = "";
        for (let i = 0; i < list.length; i++) {
            buffer += list[i];
            if (i == list.length - 1) {
                break;
            }
            else if (i == list.length - 2) {
                buffer += " " + lastElement.trim() + " ";
            }
            else {
                buffer += delimiter;
            }
        }

        return buffer;
    }

    getDisclaimer(disclaimersAllLang: DisclaimersAllLang, internalSetting: InternalSettings | null = null): string {

        if (disclaimersAllLang == null) return '';
        const defaultDisclaimer = disclaimersAllLang.English ?? '';

        if (!internalSetting) return defaultDisclaimer;

        let language = internalSetting.profile.language;

        let disclaimer: string | null;
        switch (language) {
            case 'en':
                disclaimer = disclaimersAllLang.English;
                break;
            case 'es':
                disclaimer = disclaimersAllLang.Spanish;
                break;
            case 'fr':
                disclaimer = disclaimersAllLang.French;
                break;
            case 'nl':
                disclaimer = disclaimersAllLang.Dutch;
                break;
            default:
                disclaimer = defaultDisclaimer;
                break;
        }
        return disclaimer ?? defaultDisclaimer;
    }

    getCustomerName(internalSetting: InternalSettings): string {
        if (!internalSetting) return "";
        return `${internalSetting.profile.firstName} ${internalSetting.profile.lastName}`;
    }

    getSrvTranslate() {
      return this.srvTranslate;
    }
}
